import { httpCreate } from './http';

const http = httpCreate('/srv/activityAppointmentCooperation');

export const activityAppointmentCooperation = {
	getList(params) {
		return http.get('/pageList', { params });
	},
};
